import Page from '../../classes/Page';
import { app } from '../../utils/store';
import Carousel from '../../modules/Carousel'

export default class Home extends Page {
    constructor() {
        super({
            id: 'home',
            element: '[data-app-page]',
            elements: { 
                carousel: '[data-carousel]',
                carousel_img: '[data-carousel-img]'
            }
        });
    }

    create() {
        super.create();
        if (this.elements.carousel) {
            this.createCarousel();
        }
        if (this.elements.carousel_img) {
            this.createCarouselImg()
        }
    }

    createCarousel = () => {
        this.slider = new Carousel({ element: this.elements.carousel });
        this.slider.createCarousel(this.elements.carousel);
    }

    createCarouselImg = () => {
        this.slider_img = new Carousel({ element: this.elements.carousel_img});
        this.slider_img.createCarousel(this.elements.carousel_img);
    }

    addEventListeners() {}

    destroy() {
        super.destroy();
    }
}
